import { memo, useCallback, useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import clx from 'classnames';

import SideBar from '../../SideBar';
import Header from '../../Header';
import DemoModeBanner from '../DemoModeBanner';
import { ROUTES } from '../../../routes/constants';
import useWindowSize from '../../../utils/useWindowSize';
import styles from './PageWrapper.module.scss';

/** Evita che il toggle sidebar rifaccia il render di Calendario/Statistiche/ecc. */
const MainSection = memo(({ children }) => {
  const sectionRef = useRef(null);
  const location = useLocation();

  useLayoutEffect(() => {
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={styles.section__wrapper} ref={sectionRef}>
      <DemoModeBanner />
      <section>{children}</section>
    </div>
  );
});

MainSection.displayName = 'MainSection';

const PageWrapper = ({ children }) => {
  // Solo mobile: desktop gestisce l'open internamente per non re-renderizzare Header/pagina.
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { isMobile, isTablet } = useWindowSize();
  const isCalendar = location.pathname === ROUTES.SCHEDULER;
  const isTouchCalendar = isCalendar && (isMobile || isTablet);

  const setSideBarIsOpen = useCallback((value) => {
    setMobileMenuOpen((prev) =>
      typeof value === 'function' ? value(prev) : value,
    );
  }, []);

  return (
    <div
      className={clx(styles['page-wrapper'], {
        [styles['page-wrapper_mobile_calendar']]: isMobile && isCalendar,
        [styles['page-wrapper_touch_calendar']]: isTouchCalendar,
        [styles['page-wrapper_menu_open']]: isMobile && mobileMenuOpen,
      })}
    >
      <Header
        setSideBarIsOpen={setSideBarIsOpen}
        sideBarIsOpen={mobileMenuOpen}
        isCalendar={isCalendar}
      />

      <div className={styles['content-wrapper']}>
        <SideBar
          mobileOpen={mobileMenuOpen}
          setMobileOpen={setSideBarIsOpen}
          isCalendar={isCalendar}
        />
        <MainSection>{children}</MainSection>
      </div>
    </div>
  );
};

export default PageWrapper;
